import {Injectable} from '@angular/core';

import {YearsAtAlpha} from '@app/core/models/years-at-alpha.model';
import AlphaYearsState from '@app/core/states/alpha-years.state';

@Injectable({providedIn: 'root'})
export default class AlphaYearFacade {
  public enableAll     = this._state.enableAll.bind(this._state);
  public selected$     = this._state.selected$;
  public yearsAtAlpha$ = this._state.yearsAtAlpha$;

  constructor(private readonly _state: AlphaYearsState) {
  }

  public updateYear(value: string, global = true): void {
    this._state.updateYear(value, global);
  }

  public updateYears(values: YearsAtAlpha[]): void {
    this._state.updateYears(values);
  }
}
